function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (encodeURIComponent(value) || "") + expires + "; path=/";
};


function getCookie(name) {
  const cookies = document.cookie.split('; ');
  for (let i = 0; i < cookies.length; i++) {
    const [cookieName, cookieValue] = cookies[i].split('=');
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null; // Return null if the cookie is not found
};


// Using the current window location
let params = new URLSearchParams(window.location.search);

// Extracting individual parameters
let aclid = params.get('aclid');
if (aclid!=null) {
  if(!checkcountry()){
 // Create a cookie 
    setCookie("ACLID", aclid, 30);
  }else{
    checkcookie();
  }
}
 
function checkcookie(){
    document.addEventListener("visitorConsentCollected", (event) => {
      const marketingAllowed = event.detail['marketingAllowed'];
      if(marketingAllowed){
        setCookie("ACLID", aclid, 30);
      }    
    });
  
};

  
function checkcountry() {
const countryCode=window.Shopify.customerPrivacy.getRegion();

 
let alphabeticPart = "";

for (let i = 0; i < countryCode.length; i++) {
    const char = countryCode[i];
    if (char.match(/[A-Za-z]/)) {
        alphabeticPart += char;
    } else {
        break; // Stop when you hit a non-alphabetic character
    }
}

  
    const europeanCountries = [
    'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IS',
    'IE','IT','LV','LI','LT','LU','MT','NL','NO','PL','PT','RO','SK','SI','ES','SE','GB'
];
     if (europeanCountries.includes(alphabeticPart)) {
         return true;
    } else {
       return false;
    }
  };
  

window.Shopify.loadFeatures(
 [
   {
     name: 'consent-tracking-api',
     version: '0.1',
   },
 ],
 error => {
   if (error) {
     // Rescue error
   }
   // If error is false, the API has loaded and ready to use!
 },
);


  // trigger TrafficJunky pixel on 'Add to Cart' event
       
       
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(event) {
    // Check if the clicked element is an 'Add to Cart' button
    if (event.target && (event.target.classList.contains('m-add-to-cart') || event.target.classList.contains('m-add-to-cart--text') )) {
      // Replace with your TrafficJunky member ID, ACLID, and any other dynamic parameters
      const member_id = '1006530251'; // Replace with your TrafficJunky member ID
      
      const random_number = Math.floor(Math.random() * 1000); // Generate random number
      const transaction_id = Date.now(); // Example transaction ID (you can adjust this as per your requirement)
      const value_of_transaction = '0'; // As it's an 'Add to Cart' event, the value is typically 0
      
      // Construct TrafficJunky pixel URL
      let pixelUrl = `https://ads.trafficjunky.net/ct?a=1000488231&member_id=${member_id}&cb=${random_number}&cti=${transaction_id}&ctv=${value_of_transaction}&ctd=Add to Cart`;
      
      const aclid_cookie = getCookie("ACLID");
      if (aclid_cookie!=null) {
        pixelUrl = pixelUrl.concat(`&aclid=${aclid_cookie}`);
      }
      // Create an image element (pixel) and trigger the request
      const img = new Image();
      img.id = '1000488231_cpa_testing'; // Set the ID for the image
      img.src = pixelUrl;
      img.style.width = '1px';
      img.style.height = '1px'; 
      img.style.border= 'none';

      // Append the image element to the body to trigger the request
      document.body.appendChild(img);
    }
  });
});
       



